(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["navigation-slider"] && !Shopify.designMode) return;
  try {
    
  tabs = document.querySelectorAll(".tab");
      tabContents = document.querySelectorAll(".tab-content");

      tabs.forEach(function (tab) {
        tab.addEventListener("click", function () {
          contentId = this.dataset.contentId;
          content = document.getElementById(contentId);
          tabContents.forEach(function (content) {
            content.classList.remove("active");
          });
          tabs.forEach(function (tab) {
            tab.classList.remove("active");
          });
          this.classList.add("active");
          content.classList.add("active");
        });
      });

  } catch(e) { console.error(e); }
})();
})();
